import gql from "graphql-tag";

export default gql`
  fragment EditableCommentFields on EditableComment {
    lastEditedAt
  }
`;
